import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import {
  doFindCompanies,
  setSucursalId,
  setCompanyId,
  openCloseTourConfirmation,
  setUserFunctionalities,
} from '../Global/actions';
import { dataLayerTag } from './functions';
import Logo from '../../images/logoachs.png';
import { paths } from '../../config/routes';
import MenuItem from './menuItem';
import { checkAccess, rolesValidationAccess } from '../../helpers/rolAccess';
import MainItem from './mainItem';
import mainMenu from './menuStructure';
import ModalAlert from '../Shared/modalAlert';
import { changeTabIndex } from '../Header/actions';
import { resetStateSolicitudes } from '../SucursalVirtual/Empresa/GestionUsuarios/AprobarSolicitudes/actions';
import { setTypeRelationFilter } from '../SucursalVirtual/Empresa/GestionUsuarios/Notificaciones/actions';
import { menuNavigation } from '../Main/actions';
import { fullScreenLoading } from '../Acceso/Login/actions';
import { resetDenunciasEmpresas } from '../SucursalVirtual/Empresa/SiniestrosEmpresa/Denuncias/actions';
import { resetStateSiniestroEmpresa } from '../SucursalVirtual/Empresa/SiniestrosEmpresa/Siniestros/actions';
import { resetStatePrestacionesEmpresa } from '../SucursalVirtual/Empresa/SiniestrosEmpresa/PrestacionesEconomicas/actions';
import { redirectToSEL } from './menuItemSEL';
import { loggingAgndamientoExpertoClicks } from '../../services/logging';
import { openNewTab } from '../../helpers/redirect.lib';
import { getCurrentCompanyAV2, isIframe } from 'helpers/isIframe';
const activeColor = '#fff';
const color = '#007A33';

// const bot = (visitorData) => {
//   (function (l, t) {
//     if (l.$LT) return;
//     function ls() {
//       let a = !1;
//       let s = t.createElement("script");
//       s.type = "text/javascript";
//       s.src =
//         "https://s3-us-west-2.amazonaws.com/static.production.letsta.lk/launcher/launcher.js";
//       s.async = !0;
//       s.defer = !0;
//       let k = document.getElementsByTagName("script")[0];
//       k.parentNode.insertBefore(s, k);
//     }
//     var lt = (l.$LT = function (callback) {
//       if (typeof callback === "function") {
//         mock.initCallBack = callback;
//       }
//     });
//     lt.enqueue = function () {
//       mock.stack.push(arguments);
//       mock.times.push(+new Date());
//     };
//     lt.settings = function (settings) {
//       lt.enqueue("userSettings", settings);
//     };
//     lt.chatMetadata = function (getMetadata) {
//       if (typeof getMetadata === "function") {
//         lt.enqueue("metadata", getMetadata());
//       }
//     };
//     lt.setByName = function (name) {
//       mock.name = name;
//     };
//     var mock = (lt._ = {
//       name: !1,
//       initCallBack: !1,
//       stack: [],
//       times: [+new Date()],
//     });
//     if (t.body) {
//       ls();
//     } else {
//       if (l.attachEvent) {
//         l.attachEvent("onload", ls);
//       } else {
//         l.addEventListener("load", ls, !1);
//       }
//     }
//   })(window, document);
//
//   window.$LT(function (messenger) {
//     messenger.setByName("chat-privado-achs-virtual");
//     messenger.settings({
//       organization_subdomain: "achs",
//       consumer: {
//         key: "zZYBv18bOQmDyTP_3uqo0g",
//         token: "NaNZIOXyGPlNJZyk7dr9pQ",
//       },
//       visitor: visitorData,
//     });
//   });
// };

class MenuLateral extends React.PureComponent {
  constructor(props) {
    super(props);

    if (!props.listaEmpresas) props.dispatch(doFindCompanies(props.userData.RUT));

    this.node = React.createRef();

    this.state = {
      selectCompanyOpen: false,
      selectSucursalOpen: false,
      openModal: false,
      redirect: null,
      typeRedirect: null,
      isTouch: false,
      rolUserChange: true,
      initialCompany: true,
    };

    this.handleResetMenuIndex();
  }

  componentDidMount = () => {
    window.addEventListener('storage', this.setExternalCompany);
    document.addEventListener('click', this.handleOutsideClick, false);
  };

  componentDidUpdate(prevProps) {
    if (this.props.currentPath !== prevProps.currentPath && this.props.currentPath === paths.root) {
      this.props.dispatch(
        menuNavigation({
          activeIndex: 0,
          hoverIndex: 0,
          isHovering: false,
        }),
      );
    }

    if (this.props.listaEmpresas !== prevProps.listaEmpresas) {
      if (this.props.listaEmpresas.length > 0) {
        const companyId = this.props.listaEmpresas[0].RutEmpresa;
        const companyName = this.props.listaEmpresas[0].Nombre;
        if (companyId) {
          this.props.dispatch(setCompanyId(companyId, companyName, this.handleSucursalSelect));
        }
      }
    } else if (!this.props.userAccessIds) {
      const ids = [];
      if (Array.isArray(this.props.userAccessList)) {
        this.props.userAccessList.forEach((func) => {
          ids.push(func.Code.trim());
        });
        this.props.dispatch(setUserFunctionalities(ids));
        this.props.dispatch(fullScreenLoading(false));
      }
    }
    // TDOD: agregar función de cmabio de sucursal?
    if (this.state.rolUserChange && this.props.companyId) {
      const eventName = this.state.initialCompany ? 'login' : 'companyChange';

      const rolUser =
        this.props.userAccessList &&
        this.props.userAccessList
          .filter((e) => e.CompanyId === this.props.companyId)
          .map((e) => e.RolName);
      const uniqueRoleUser =
        rolUser && rolUser.reduce((acc, curr) => (acc.includes(curr) ? acc : [...acc, curr]), []);
      const CompanyName =
        this.props.listaEmpresas &&
        this.props.listaEmpresas
          .filter((e) => e.RutEmpresa === this.props.companyId)
          .map((e) => e.Nombre);
      dataLayerTag({
        event: eventName,
        rut: this.props.userData.RUT,
        companyrut: this.props.companyId,
        rol_admin: this.rolFinder(uniqueRoleUser, 'Admin'),
        rol_dependiente: this.rolFinder(uniqueRoleUser, 'Dependiente'),
        rol_independiente: this.rolFinder(uniqueRoleUser, 'Independiente'),
        rol_lgf: this.rolFinder(uniqueRoleUser, 'LGF'),
        rol_trabajador_achs: this.rolFinder(uniqueRoleUser, 'Trabajador ACHS'),
        rol_portal_empresa: this.rolFinder(uniqueRoleUser, 'Portal Empresa'),
        rol_autoasignacion_achs: this.rolFinder(uniqueRoleUser, 'Autoasignacion ACHS'),
        rol_prevencion: this.rolFinder(uniqueRoleUser, 'Prevención'),
        rol_siniestros: this.rolFinder(uniqueRoleUser, 'Siniestros'),
        rol_exachs: this.rolFinder(uniqueRoleUser, 'Ex-Achs'),
        rol_contact_center: this.rolFinder(uniqueRoleUser, 'Contact Center'),
        rol_inbox_sel: this.rolFinder(uniqueRoleUser, 'Inbox SEL'),
        rol_gestor_sel: this.rolFinder(uniqueRoleUser, 'Gestor SEL'),
        rol_solicitante_sel: this.rolFinder(uniqueRoleUser, 'Solicitante SEL'),
        rol_admin_achs_virtual: this.rolFinder(uniqueRoleUser, 'Admin ACHS Virtual'),
        rol_achs_gestion: this.rolFinder(uniqueRoleUser, 'ACHS Gestión'),
        empresa: CompanyName[0],
      });

      this.setState({
        rolUserChange: false,
        initialCompany: false,
      });
    }
  }

  rolFinder = (arr, rol) => {
    const UserRol = arr && arr.find((e) => e === rol);
    return UserRol ? 'True' : 'False';
  };

  componentWillUnmount = () => {
    window.removeEventListener('storage', this.setExternalCompany);
    document.removeEventListener('click', this.handleOutsideClick, false);
  };

  setExternalCompany = () => {
    const rutEmpresa = getCurrentCompanyAV2();
    const { listaEmpresas, companyId } = this.props;
    if (listaEmpresas.length > 0 && rutEmpresa && isIframe && rutEmpresa !== companyId) {
      const company = listaEmpresas.find((e) => e.RutEmpresa === rutEmpresa);
      if (company) {
        const { RutEmpresa, Nombre } = company;
        this.props.dispatch(setCompanyId(RutEmpresa, Nombre, this.handleSucursalSelect));
      }
    }
  };

  getCompany = (e, value) => {
    this.props.dispatch(setTypeRelationFilter('INT'));
    this.props.dispatch(push(paths.siniestrosEmpresa));
    this.props.dispatch(setCompanyId(value.RutEmpresa, value.Nombre, this.handleSucursalSelect));
    this.handleResetMenuIndex();
    this.props.dispatch(changeTabIndex(0, 0));

    this.props.dispatch(resetStateSolicitudes());
    this.props.dispatch(resetDenunciasEmpresas());
    this.props.dispatch(resetStateSiniestroEmpresa());
    this.props.dispatch(resetStatePrestacionesEmpresa());
    this.setState({ rolUserChange: true });
  };

  getSucursal = (e, value) => {
    this.props.dispatch(setSucursalId(value.IdSucursal, value.Direccion));
  };

  getCurrentActiveIndex = () => {
    let mainIndex = 0;
    mainMenu.forEach((menu, index) => {
      const subMenuActive = menu.subMenu.find((item) => item.route === this.props.currentPath);
      if (subMenuActive != null) {
        mainIndex = index;
      }
    });

    return mainIndex;
  };

  handleSucursalSelect = (open) => {
    if (this.state.selectSucursalOpen && open) {
      open = false;
    }
    this.setState({ selectSucursalOpen: open });
  };

  handleResetMenuIndex = () => {
    if (this.getCurrentActiveIndex() === 0) this.props.collapseMenu();
    this.props.dispatch(
      menuNavigation({
        activeIndex: this.getCurrentActiveIndex(),
        hoverIndex: this.getCurrentActiveIndex(),
        isHovering: false,
      }),
    );
  };

  goTo = (route) => {
    if (this.props.preventNavigation) {
      this.setState({
        openModal: true,
        redirect: route,
        typeRedirect: 'routes',
      });
    } else {
      this.props.dispatch(push(route));
    }
  };

  handleCompanySelect = (open) => {
    let isOpen = open;
    if (this.state.selectCompanyOpen && open) {
      isOpen = false;
    }
    this.setState({ selectCompanyOpen: isOpen });
  };

  handleHover = (index, isHover) => {
    if (!isHover && (this.state.selectCompanyOpen || this.state.selectSucursalOpen)) {
      this.props.dispatch(
        menuNavigation({
          hoverIndex: this.props.menuHoverIndex,
          isHovering: true,
        }),
      );
      return;
    }

    this.props.dispatch(
      menuNavigation({
        hoverIndex: index,
        isHovering: isHover,
      }),
    );
  };

  handleOutsideClick = (e) => {
    if (this.props.isTourOpen) return;
    if (!this.props.isExpanded && !this.props.menuIsHovering) return;
    if (this.props.isExpanded && this.props.allowExpand) return;
    if (!(this.state.selectCompanyOpen || this.state.selectSucursalOpen)) {
      if (!this.node.contains(e.target)) {
        this.handleResetMenuIndex();
      }
    }
  };

  closeModal = () => {
    this.setState({
      openModal: false,
      redirect: null,
      typeRedirect: null,
    });
  };

  handleUrlNavigation = (url) => {
    window.open(url, '_blank');
  };

  handleMenuClick = (index, menu, isTouch) => {
    if (menu.route === '/agenda-sel') {
      redirectToSEL(this.props.companyId);
      return;
    }
    if (menu.noExpand) {
      this.props.collapseMenu();
    } else if (!this.props.isExpanded && this.props.allowExpand) {
      this.props.expandMenu();
    }
    if (isTouch) {
      this.setState({ isTouch: true });
      this.props.dispatch(
        menuNavigation({
          activeIndex: index,
          hoverIndex: index,
          isHovering: !(this.props.menuIsHovering && this.props.menuActiveIndex === index),
        }),
      );
    } else if (!menu.noClick) {
      this.props.dispatch(
        menuNavigation({
          activeIndex: index,
          hoverIndex: index,
          isHovering: false,
        }),
      );
      this.goTo(menu.route);
    }
  };

  handleSubMenuClick = (route, item) => {
    const rolUser =
      this.props.userAccessList &&
      this.props.userAccessList
        .filter((e) => e.CompanyId === this.props.companyId)
        .map((e) => e.RolName);
    const uniqueRoleUser =
      rolUser && rolUser.reduce((acc, curr) => (acc.includes(curr) ? acc : [...acc, curr]), []);
    const CompanyName =
      this.props.listaEmpresas &&
      this.props.listaEmpresas
        .filter((e) => e.RutEmpresa === this.props.companyId)
        .map((e) => e.Nombre);

    let dataObject = {
      event: item.name,
      rut: this.props.userData.RUT,
      companyrut: this.props.companyId,
      rol_admin: this.rolFinder(uniqueRoleUser, 'Admin'),
      rol_dependiente: this.rolFinder(uniqueRoleUser, 'Dependiente'),
      rol_independiente: this.rolFinder(uniqueRoleUser, 'Independiente'),
      rol_lgf: this.rolFinder(uniqueRoleUser, 'LGF'),
      rol_trabajador_achs: this.rolFinder(uniqueRoleUser, 'Trabajador ACHS'),
      rol_portal_empresa: this.rolFinder(uniqueRoleUser, 'Portal Empresa'),
      rol_autoasignacion_achs: this.rolFinder(uniqueRoleUser, 'Autoasignacion ACHS'),
      rol_prevencion: this.rolFinder(uniqueRoleUser, 'Prevención'),
      rol_siniestros: this.rolFinder(uniqueRoleUser, 'Siniestros'),
      rol_exachs: this.rolFinder(uniqueRoleUser, 'Ex-Achs'),
      rol_contact_center: this.rolFinder(uniqueRoleUser, 'Contact Center'),
      rol_inbox_sel: this.rolFinder(uniqueRoleUser, 'Inbox SEL'),
      rol_gestor_sel: this.rolFinder(uniqueRoleUser, 'Gestor SEL'),
      rol_solicitante_sel: this.rolFinder(uniqueRoleUser, 'Solicitante SEL'),
      rol_admin_achs_virtual: this.rolFinder(uniqueRoleUser, 'Admin ACHS Virtual'),
      rol_achs_gestion: this.rolFinder(uniqueRoleUser, 'ACHS Gestión'),
      empresa: CompanyName ? CompanyName[0] : null,
    };
    if (item.url) {
      if (item.evaluarIndependiente) {
        const urlAutoEvaluacion = `${item.url}${
          !item.skiptoken ? localStorage.getItem('AccessToken') : ''
        }&opcion=${
          dataObject.rol_independiente == 'True' ? '2' : '1' //this.props.userData.RUT == this.props.companyId ? "2" : "1"
        }${
          !item.skiptoken
            ? `&rut=${
                dataObject.rol_independiente == 'True'
                  ? String(this.props.userData.RUT).toLowerCase()
                  : String(this.props.companyId).toLowerCase()
              }`
            : ''
        }`;
        //this.handleUrlNavigation(urlAutoEvaluacion);
        openNewTab(urlAutoEvaluacion);
        dataLayerTag(dataObject);
      } else if (item.agendamientoExperto) {
        loggingAgndamientoExpertoClicks(this.props.companyId, this.props.companyName);
        this.handleUrlNavigation(
          `${item.url}${
            !item.skiptoken
              ? `${localStorage.getItem('AccessToken')}&rt=${localStorage.getItem(
                  'RefreshToken',
                )}&rut=${this.props.companyId}`
              : ''
          }`,
        );
        dataLayerTag(dataObject);
      } else {
        this.handleUrlNavigation(
          `${item.url}${!item.skiptoken ? localStorage.getItem('AccessToken') : ''}${
            !item.skiptoken ? `&rut=${this.props.companyId}` : ''
          }`,
        );
        dataLayerTag(dataObject);
      }
    } else if (item.tour) {
      this.props.dispatch(openCloseTourConfirmation(true));
    } else {
      this.goTo(route);
      this.props.dispatch(
        menuNavigation({
          activeIndex: this.props.menuHoverIndex,
          isHovering: false,
        }),
      );
    }
  };

  handleAchsLogoClick = () => {
    if (this.props.currentPath !== paths.root) {
      this.goTo(paths.root);
      this.props.collapseMenu();
    }
  };

  renderSubMenuMyAccount = () =>
    mainMenu
      .filter((x) => x.route === paths.perfil)
      .subMenu.map((item) => (
        <MenuItem
          key={item.name}
          name={item.name}
          icon={item.icon}
          route={item.route}
          navigate={(route) => {
            this.goTo(route);
            this.props.dispatch(
              menuNavigation({
                activeIndex: this.props.menuHoverIndex,
                isHovering: false,
              }),
            );
          }}
          selected={item.route === this.props.currentPath}
        />
      ));

  renderSubmenuItems = (index) => {
    const finalMenu = [];
    const tourDiv = [];
    const subMenu = mainMenu[index] && mainMenu[index].subMenu;
    subMenu.forEach((item) => {
      if (checkAccess(item.accessId, this.props.userAccessIds)) {
        const subMenuItem = (
          <MenuItem
            key={item.name}
            name={item.name}
            id={item.tourId}
            icon={item.icon}
            iconFile={item.iconFile}
            route={item.route}
            navigate={(route) => {
              this.handleSubMenuClick(route, item);
            }}
            selected={item.route === this.props.currentPath}
          />
        );
        if (item.tourSection) {
          tourDiv.push(subMenuItem);
        } else {
          finalMenu.push(subMenuItem);
        }
      }
    });

    return (
      <React.Fragment>
        {finalMenu}
        <div id='tour_menu_section'>{tourDiv}</div>
      </React.Fragment>
    );
  };
  renderSpacer = () => (
    <div className='menu-spacer' style={{ backgroundColor: activeColor, flex: 1 }}>
      <div style={{ backgroundColor: color, height: '100%' }}></div>
    </div>
  );

  renderModalAlert() {
    return (
      <React.Fragment>
        <ModalAlert
          open={this.state.openModal}
          title='Alerta'
          message='¿Ha modificado la información de sus datos, desea guardarlos?'
          closeModalCall={this.closeModal}
          redirect={this.state.redirect}
          typeRedirect={this.state.typeRedirect}
        />
      </React.Fragment>
    );
  }

  // startBot() {
  //   bot(visitor);
  // }

  render() {
    let { companyId, userAccessIds, isExpanded, width } = this.props;

    const actualIndex = this.props.menuIsHovering
      ? this.props.menuHoverIndex
      : this.props.menuActiveIndex;
    if (!isExpanded && this.props.menuIsHovering) {
      width = 290;
    }

    return (
      <>
        {/*{this.props.tokenJwt && (*/}
        {/*  <script type="text/javascript" async defer>*/}
        {/*    {this.startBot()}*/}
        {/*  </script>*/}
        {/*)}*/}

        <div
          ref={(ref) => {
            this.node = ref;
          }}
          onClickCapture={this.handleOutsideClick}
          className='menu-animation-width'
          style={{
            width,
          }}
        >
          {this.renderModalAlert()}
          <div className='menu-area'>
            <div className='main-menu'>
              <img
                onClickCapture={this.handleAchsLogoClick}
                src={Logo}
                alt='logo'
                className='menu-logo'
              />
              {!mainMenu[actualIndex].noExpand &&
                this.props.allowExpand &&
                !this.props.isExpanded &&
                !this.props.menuIsHovering && (
                  <div className='expand-button' onClickCapture={this.props.expandMenu}>
                    <i
                      className='achs-icon'
                      style={{
                        transform: 'rotate(180deg)',
                        marginTop: 11,
                        fontSize: 30,
                        color: 'white',
                      }}
                    >
                      j
                    </i>
                  </div>
                )}
              {mainMenu.map(
                (menu, index) =>
                  checkAccess(menu.accessId, userAccessIds) &&
                  !menu.hidden && (
                    <React.Fragment key={menu.icon}>
                      {menu.stackBottom && this.renderSpacer()}
                      <MainItem
                        id={menu.tourId}
                        text={menu.name}
                        icon={menu.icon}
                        isTouch={this.state.isTouch}
                        noExpand={menu.noExpand}
                        isHovering={this.props.menuHoverIndex === index}
                        active={this.props.menuActiveIndex === index}
                        onMouseEnter={(shouldHover) => this.handleHover(index, shouldHover)}
                        onClick={() => {
                          if (!menu.noClick) this.handleMenuClick(index, menu, false);
                        }}
                        onTouch={() => {
                          this.handleMenuClick(index, menu, true);
                        }}
                      />
                    </React.Fragment>
                  ),
              )}
            </div>

            {
              <div
                className={`submenu ${width > 70 ? 'show-sub-menu' : ''}`}
                onMouseLeave={() => this.handleHover(actualIndex, false)}
              >
                <div className='submenu-name'>
                  {mainMenu[actualIndex] && mainMenu[actualIndex].name}
                </div>

                <div className='description-sub-menu'>
                  {mainMenu[actualIndex] && mainMenu[actualIndex].description}
                </div>
                {/* {mainMenu[actualIndex].showSelects && ( */}
                {/* <React.Fragment>
                <SelectEmpresas
                  show={mainMenu[actualIndex].showSelects}
                  dataSource={this.props.listaEmpresas}
                  value={companyId}
                  handleChange={this.getCompany}
                  isHovering={this.props.menuIsHovering}
                  open={this.state.selectCompanyOpen}
                  handleOpenClose={this.handleCompanySelect}
                  onMouseEnter={() => this.handleHover(actualIndex, true)}
                />
                <SelectSucursales
                  show={mainMenu[actualIndex].showSelects}
                  dataSource={[
                    { Direccion: "Todas las sucursales", IdSucursal: "" },
                    ...this.props.companySucursales,
                  ]}
                  value={this.props.sucursalId}
                  handleChange={this.getSucursal}
                  isHovering={this.props.menuIsHovering}
                  open={this.state.selectSucursalOpen}
                  handleOpenClose={this.handleSucursalSelect}
                  onMouseEnter={() => this.handleHover(actualIndex, true)}
                />
              </React.Fragment> */}
                {/* )} */}
                {/* <div
                  style={
                    mainMenu[actualIndex].showSelects
                      ? {
                          marginTop: 20,
                          paddingTop: 20,
                          borderTop: "1px solid white",
                        }
                      : {}
                  }
                > */}
                <div style={{ marginTop: 20, paddingTop: 20, borderTop: '1px solid white' }}>
                  {this.renderSubmenuItems(actualIndex)}
                </div>
              </div>
            }

            {this.props.isExpanded && (
              <div className='collapse-button'>
                <MainItem
                  key='chevron_left'
                  text='Colapsar'
                  icon='j'
                  onClick={() => {
                    this.props.collapseMenu();
                    this.props.dispatch(
                      menuNavigation({
                        isHovering: false,
                      }),
                    );
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  currentPath: state.router.location.pathname,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  companyName: state.global.companyName,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  listaEmpresas: state.global.listaEmpresas,
  companySucursales: state.global.companySucursales,
  preventNavigation: state.global.preventNavigation,
  isOpenAccountMenu: state.header.isOpenAccountMenu,
  menuHoverIndex: state.main.menuHoverIndex,
  menuIsHovering: state.main.menuIsHovering,
  menuActiveIndex: state.main.menuActiveIndex,
  isTourOpen: state.global.isTourOpen,
  userAccessList: state.global.userAccessList,
  tokenJwt: state.headerNotificaciones.tokenJwt,
  currentRoles: state.global.myCompanyRoles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(MenuLateral);
